var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon } from "../../UI";
import { isClient } from "../../utils";
import { loadLinks, addLink, sortLink, saveLinks } from "../actions/navlinksActions";
import { Translate } from "../../I18N";
import validator from "../utils/ValidateNavlinks";
import { DNDHTMLBackend } from "../../App/DNDHTML5Backend";
import NavlinkForm from "./NavlinkForm";
import { SettingsHeader } from "./SettingsHeader";
import "./styles/menu.scss";

class NavlinksSettings extends Component {
  componentDidMount() {
    this.props.loadLinks(this.props.collection.get('links').toJS());
    this.firstLoad = true;
  }

  // TEST!!!
  componentDidUpdate(previousProps) {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }

    this.focusOnNewElement(previousProps);
  }

  // TEST!!!
  focusOnNewElement(previousProps) {
    const { links } = this.props;
    const previousLinks = previousProps.links;
    const hasNewBlock = links.length > previousLinks.length;
    if (hasNewBlock) {
      this.blockReferences[this.blockReferences.length - 1].focus();
    }
  }

  render() {
    const { collection, links } = this.props;
    const hostname = isClient ? window.location.origin : '';

    const payload = { _id: collection.get('_id'), _rev: collection.get('_rev'), links };

    this.blockReferences = [];

    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "NavlinksSettings" }, void 0, /*#__PURE__*/
      _jsx(Form, {
        model: "settings.navlinksData",
        onSubmit: this.props.saveLinks.bind(this, payload),
        className: "navLinks",
        validators: validator(links) }, void 0, /*#__PURE__*/

      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Menu")
      ), /*#__PURE__*/
      _jsx("ul", { className: "list-group" }, void 0, /*#__PURE__*/
      _jsx("li", { className: "list-group-item" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "If it is an external URL, use a fully formed URL. Ie. http://www.uwazi.io."

      ), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, { translationKey: "Navigation menu tool tip part 1" }, void 0, "If it is an internal URL within this website, be sure to delete the first part"


      ), ' ', "(",
      hostname, "),", ' ', /*#__PURE__*/
      _jsx(Translate, { translationKey: "Navigation menu tool tip part 2" }, void 0, "leaving only a relative URL starting with a slash character. Ie. /some_url."

      )
      )
      )
      ),
      links.map((link, i) => /*#__PURE__*/
      _jsx(NavlinkForm, {

        index: i,
        id: link.localID || link._id,
        link: link,
        sortLink: this.props.sortLink,
        blockReferences: this.blockReferences }, link.localID || link._id
      )
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default",
        id: "main-add-link-button",
        onClick: this.props.addLink.bind(this, links, 'link') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "link" }), "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add link")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.props.addLink.bind(this, links, 'group') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "caret-square-down" }), "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add group")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "submit",
        className: "btn btn-success btn-extra-padding",
        disabled: !!this.props.savingNavlinks }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )
      )
      )
      )
      ));

  }
}











const mapStateToProps = (state) => {
  const { settings } = state;
  const { collection } = settings;
  const { links } = settings.navlinksData;
  return { links, collection, savingNavlinks: settings.uiState.get('savingNavlinks') };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadLinks, addLink, sortLink, saveLinks }, dispatch);
}

export { NavlinksSettings, mapStateToProps };

export default DNDHTMLBackend(connect(mapStateToProps, mapDispatchToProps)(NavlinksSettings));